module.exports = __webpack_public_path__ + "static/img/sa-edit.b98222a2.svg";